import { useContext } from "react";
import { ModalContext } from "../context/Modal.js";
export function useModal() {
    const { spawnModal, despawnModal, despawnAllModals, data } = useContext(ModalContext);
    return {
        spawnModal,
        despawnModal,
        despawnAllModals,
        data,
    };
}
//# sourceMappingURL=useModal.js.map